import React from "react";
import { SHStack } from "@components/design-systems";
import { EyeIcon } from "@components/svgs/eye";
import { SHRichTextTooltip } from "@components/design-systems/sh-rich-text-tooltip";
import { VisibilityMessage } from "@pages/suppliers/constants";

export const MSTableRestrictedCell = React.memo(() => {
  return (
    <SHStack>
      <SHRichTextTooltip
        customIcon={<EyeIcon isActive={false} />}
        htmlContent={VisibilityMessage.FEATURE_LEVEL}
      />
    </SHStack>
  );
});
